export const COLOR_DEFAULTS = [
  "green.500",
  "purple.500",
  "blue.500",
  "orange.500",
  "red.500",
];
